const setUpPaymentPlan = 'Set up a payment plan';

export default {
  intro: {
    screenTitle: 'Big purchase?\nSplit it up.',
    subtitle:
      'Plan ahead and split your next debit card purchase into 4 payments for a 6% fee.',
    disclosure:
      'Payments vary by purchase amount. For a $500 purchase, you’ll make 4 payments of $132.50 every 15 days. This includes a $30 fee. 0% down. 57.72% APR.',
    setUpPaymentPlan,
    howItWorks: 'How it works',
  },
  howItWorks: {
    navigationTitle: 'How Pay Later works',
    setUpPaymentPlan,
    purchaseRestrictions: {
      body: 'You can’t use Pay Later for some types of purchases.',
      link: 'See Pay Later purchase restrictions.',
    },
    steps: {
      planPurchase: {
        title: 'Plan your purchase',
        body: 'Tell us how much you want to spend to see your estimated payments.',
      },
      payWithDebitCard: {
        title: 'Pay with your debit card',
        body: 'Use your debit card to pay for your purchase. Pay Later splits your purchase into 4 payments, so you pay $0 at checkout.',
      },
      getFinalPlan: {
        title: 'Get your final plan',
        body: 'See your exact payment amounts and schedule after your purchase.\n\nBefore you buy, you’ll see an estimate.',
      },
    },
  },
  loadingSequence: {
    settingUp: 'Setting up your payment plan',
    crunchingNumbers: 'Crunching the numbers',
    checkingDetails: 'Checking the details',
    body: 'This should only take a moment.',
    longWait: {
      title: 'This may take a couple minutes',
      body: 'We’ll continue to set up your plan in the background and let you know as soon as it’s ready.\n\nLeaving this page will not cancel your application.',
      finishInBackground: 'Finish in background',
    },
  },
  setUpSuccess: {
    eyebrow: 'Set up complete',
    title: 'Pay Later is on',
    checkoutInstructionStart: 'At checkout, choose',
    checkoutInstructionCredit: 'Credit',
    checkoutInstructionEnd:
      '. Your next eligible debit card purchase will be split into 4 payments.',
    useBy: 'Use your plan by {{date}} at {{time}}.',
    done: 'Done',
  },
  setUpError: {
    title: 'We couldn’t set up your payment plan',
    body: 'Something went wrong while setting up your plan. Try again.',
    tryAgain: 'Try again',
    done: 'Done',
  },
  purchaseAmount: {
    title: 'How much do you plan to spend?',
    body: 'Add extra for taxes and shipping. If you spend less, we’ll update your plan to match.',
    amountLabel: 'Purchase amount',
    amountPlaceholder: '$0',
    purchasingPower: 'Your purchasing power is {{amount}}.',
    overPurchasingPower: 'Enter an amount of {{amount}} or less.',
    underMinimum: 'Enter an amount of at least {{amount}}.',
    purchasingPowerError: {
      title: 'We couldn’t load your purchasing power',
      body: 'Something went wrong. Try again.',
      tryAgain: 'Try again',
      done: 'Done',
    },
    restrictions: 'You can’t use Pay Later for some types of purchases. See',
    restrictionsLink: 'Pay Later purchase restrictions.',
    next: 'Next',
  },
  review: {
    title: 'Review your plan',
    whatCouldChange: 'What could change?',
    paymentMethod: 'Payment method',
    scheduleDescription:
      'Payment amounts are estimates. You’ll see your payment dates after purchase.',
    truthInLending: 'Pay Later Truth in Lending Disclosure and Agreement',
    expiryNotice:
      'After you confirm, your plan will apply to your next eligible debit card purchase.',
    confirm: 'Confirm payment plan',
    cancel: 'Cancel',
  },
  whatCouldChange: {
    title: 'What could change?',
    finalAmount:
      'Your final purchase amount may be higher or lower than your estimate. This can happen if the store charges a different amount for tax, shipping, or other costs.',
    planUpdates:
      'If it changes, we’ll update your plan. If the amount goes up, your payments will increase. If it goes down, your payments will decrease.',
    done: 'Done',
  },
  purchaseRestrictions: {
    title: 'Pay Later purchase restrictions',
    body: 'You can’t use Pay Later for some types of purchases, including:',
    restrictions: {
      diningTravel: 'Paying for restaurants, hotels, or car rentals',
      ridesDelivery: 'Paying for rides or delivery services',
      gasPumps: 'Paying at gas pumps',
      gambling: 'Gambling or buying lottery tickets',
      cash: 'Getting cash or cash advances',
      restrictedProducts: 'Buying alcohol or other restricted products',
      cryptocurrency: 'Buying cryptocurrency',
      prepaidGiftCards: 'Buying prepaid or gift cards',
      taxesBailPawn: 'Paying taxes, bail, or pawn shops',
      jewelryPreciousMetals: 'Buying jewelry or precious metals',
    },
    done: 'Done',
  },
};
